import React from 'react';
import ReactMarkdown from 'react-markdown';
import Modal from './Modal';

const SummaryModal = ({ isOpen, onClose, summary }) => {
  if (!summary) return null;

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="Session Summary"
      maxWidth="max-w-3xl"
    >
      <div className="max-h-[70vh] overflow-y-auto pr-2 custom-scrollbar">
        <div className="prose prose-sm md:prose-base max-w-none text-[var(--text-secondary)] dark:text-[var(--text-primary)] prose-headings:text-[var(--text-primary)] prose-headings:font-bold prose-strong:text-[var(--text-primary)] dark:prose-invert">
          <ReactMarkdown>{summary.summary_text}</ReactMarkdown>
        </div>
      </div>
      <div className="mt-8 flex justify-end">
        <button 
          onClick={onClose}
          className="px-6 py-2.5 bg-[var(--off-white)] border border-[var(--border-light)] rounded-xl text-sm font-bold text-[var(--text-secondary)] hover:bg-[var(--border-light)]/20 transition-all"
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default SummaryModal;
